export const Global = {
    // API_URL: "http://localhost:44342/api/",
    // PHOTO_URL: "http://localhost:44342/Uploads/",
    
    API_URL: "https://api.ossakbire.com/api/",
    PHOTO_URL: "https://api.ossakbire.com/Uploads/",
  };